// import React, { useRef, useState } from "react";
// import { message, Button, Form, Input, Row, Col, Modal, Upload } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { dispatchtoast, emailPattern, mobilePattern } from "../../../utils";
// import CommonInput from "../../../Common/CommonInput";
// import { MenuListendpoint } from "./MenuListEndpoint";
// import { PlusOutlined } from "@ant-design/icons";
// import { AddMenu_List } from "../../../ApiServices/Apifun";

// const AddMenu = ({
//     isOpen,
//     setIsOpen,
//     FetchMenuList,
//     from,
//     Fill,
//     addingCategory,
//     addSubcategory,
// }) => {
//     const [form] = Form.useForm();
//     const [logoFile, setLogoFile] = useState(null);
//     const [loader, setloader] = useState(false);
//     //   const [selectedMember, setSelectedMember] = useState(null);
//     const profiledetail = useSelector((state) => state.B2B.profileDetail);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const formRef = useRef(form);
//     const handleOk = () => {
//         form
//             .validateFields()
//             .then((values) => {
//                 form.resetFields();
//                 // createCategory(values);
//             })
//             .catch((info) => {
//                 console.log("Validate Failed:", info);
//             });
//     };

//     const handleCancel = () => {
//         setIsOpen(false);
//     };



//     const handleAddBrand = (val) => {
//         const formData = new FormData();

//         if (!logoFile) {
//             message.error("Please upload a logo");
//             return;
//         }


//         formData.append("foodName", val.foodName);
//         formData.append("categoryName", val.categoryName);

//         if (logoFile && logoFile instanceof File) {
//             formData.append("image", logoFile);
//         }

//         setloader(true);

//         AddMenu_List(formData)
//             .then((res) => {
//                 if (res.status) {
//                     dispatchtoast(res.message);
//                     setloader(false);
//                     setIsOpen(false);
//                     FetchMenuList();
//                     form.setFieldValue(null)
//                 } else {
//                     setloader(false);
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//                 setloader(false);
//             });
//     };

//     const uploadProps = {
//         beforeUpload: (file) => {
//             const isImage = file.type.startsWith("image/");
//             if (!isImage) {
//                 message.error("Only image files allowed!");
//                 return Upload.LIST_IGNORE;
//             }
//             setLogoFile(file);
//             return false;
//         },
//         fileList: logoFile ? [logoFile] : [],
//         onRemove: () => setLogoFile(null),
//         listType: "picture-card",
//     };





//     return (
//         <Modal
//             footer={null}
//             visible={isOpen}
//             onOk={handleOk}
//             onCancel={handleCancel}
//             title={"Add Food Menu"}
//         >
//             <Form
//                 form={form}
//                 ref={formRef}
//                 name="basic"
//                 initialValues={{
//                     remember: true,
//                 }}
//                 onFinishFailed={(err) => console.log(err)}
//                 onFinish={(val) => handleAddBrand(val)}
//             >
//                 {/* <p className="text-md text-primary font-semibold">Add Member</p> */}
//                 <p className="mt-4 font-semibold">Member Details</p>
//                 <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-x-5">
//                     <Form.Item
//                         name={`foodName`}
//                         label={"food Name"}
//                         labelCol={{ span: 24 }}
//                         rules={[
//                             {
//                                 required: true,
//                                 message: "Enter Food Name!",
//                             },
//                             {
//                                 whitespace: true,
//                                 message: "Field cannot contain only blank spaces",
//                             },
//                         ]}
//                     >
//                         <CommonInput
//                             placeholder="Enter Your Food Name"
//                             name="foodName"
//                         />
//                     </Form.Item>

//                     <Form.Item
//                         name={`categoryName`}
//                         label={"Category Name"}
//                         labelCol={{ span: 24 }}
//                         rules={[
//                             {
//                                 required: true,
//                                 message: "Enter Category Name!",
//                             },
//                             {
//                                 whitespace: true,
//                                 message: "Field cannot contain only blank spaces",
//                             },
//                         ]}
//                     >
//                         <CommonInput
//                             placeholder="Please enter your Category Name"
//                             name="categoryName"
//                         />
//                     </Form.Item>{" "}


//                     <Form.Item label="Food Image" required>
//                         <Upload {...uploadProps}>
//                             {!logoFile && (
//                                 <div>
//                                     <PlusOutlined />
//                                     <div style={{ marginTop: 8 }}>Upload</div>
//                                 </div>
//                             )}
//                         </Upload>
//                     </Form.Item>

//                 </div>

//                 <div className="flex justify-start items-center mt-2">
//                     <Form.Item>
//                         <Button
//                             loading={loader}
//                             htmlType="submit"
//                             className="bg-primary outline-none border-none text-white"
//                         >
//                             Save
//                         </Button>
//                     </Form.Item>
//                 </div>
//             </Form>
//         </Modal>
//     );
// };

// export default AddMenu;

// src/Views/Main Panel/MenuList/AddMenu.jsx
import React, { useState, useEffect } from "react";
import {
  Modal, Form, Input, Select, Upload, Button, Switch,
  message, Divider, InputNumber, Tag, Space, Tooltip
} from "antd";
import {
  PlusOutlined, InfoCircleOutlined,
  FireOutlined
} from "@ant-design/icons";
import { dispatchtoast } from "../../../utils";
import {
  AddMenu_List,
  getCategoryList,
  getVendorsDetails,
  getallrestroList,
} from "../../../ApiServices/Apifun";

const { Option } = Select;
const { TextArea } = Input;
const { Dragger } = Upload;

// ── Variant row component ────────────────────────────────
const VariantRow = ({ variant, index, onChange, onRemove }) => (
  <div className="flex items-center gap-2 mb-2">
    <Input
      placeholder="Size (e.g. Half, Full)"
      value={variant.size}
      onChange={(e) => onChange(index, "size", e.target.value)}
      className="flex-1"
      size="middle"
    />
    <InputNumber
      placeholder="Price"
      value={variant.price}
      onChange={(val) => onChange(index, "price", val)}
      className="flex-1"
      min={0}
      prefix="₹"
      size="middle"
    />
    <Button
      size="small"
      danger
      onClick={() => onRemove(index)}
      className="shrink-0"
    >
      ✕
    </Button>
  </div>
);

// ── Main component ───────────────────────────────────────
const AddMenu = ({ isOpen, setIsOpen, FetchMenuList }) => {
  const [form] = Form.useForm();
  const [imageFiles, setImageFiles] = useState([]);
  const [loader, setLoader] = useState(false);
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [loadingCat, setLoadingCat] = useState(false);
  const [loadingVen, setLoadingVen] = useState(false);
  const [loadingRest, setLoadingRest] = useState(false);
  const [variants, setVariants] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const [ingredientInput, setIngredientInput] = useState("");
  const [isVeg, setIsVeg] = useState(true);

  // ── Fetch reference data on open ────────────────────
  useEffect(() => {
    if (isOpen) {
      fetchCategories();
      fetchVendors();
      fetchRestaurants();
    }
  }, [isOpen]);

  const fetchCategories = async () => {
    setLoadingCat(true);
    try {
      const res = await getCategoryList();
      if (res?.status === "success") setCategories(res.data?.categories || []);
    } catch { /* silent */ }
    finally { setLoadingCat(false); }
  };

  const fetchVendors = async () => {
    setLoadingVen(true);
    try {
      const res = await getVendorsDetails();
      if (res?.status === "success") setVendors(res.data?.vendor || []);
    } catch { /* silent */ }
    finally { setLoadingVen(false); }
  };

  const fetchRestaurants = async () => {
    setLoadingRest(true);
    try {
      const res = await getallrestroList();
      if (res?.status) {
        setRestaurants(res.data?.restaurants || res.data || []);
      }
    } catch { /* silent */ }
    finally { setLoadingRest(false); }
  };

  // ── Reset & close ────────────────────────────────────
  const handleCancel = () => {
    form.resetFields();
    setImageFiles([]);
    setVariants([]);
    setIngredients([]);
    setIngredientInput("");
    setIsVeg(true);
    setIsOpen(false);
  };

  // ── Variant helpers ──────────────────────────────────
  const addVariant = () =>
    setVariants((v) => [...v, { size: "", price: "" }]);

  const updateVariant = (i, key, val) =>
    setVariants((v) => v.map((r, idx) => (idx === i ? { ...r, [key]: val } : r)));

  const removeVariant = (i) =>
    setVariants((v) => v.filter((_, idx) => idx !== i));

  // ── Ingredient helpers ───────────────────────────────
  const addIngredient = () => {
    const val = ingredientInput.trim();
    if (val && !ingredients.includes(val)) {
      setIngredients((g) => [...g, val]);
      setIngredientInput("");
    }
  };

  const removeIngredient = (ing) =>
    setIngredients((g) => g.filter((i) => i !== ing));

  // ── Upload config ────────────────────────────────────
  const uploadProps = {
    multiple: true,
    maxCount: 5,
    listType: "picture-card",
    fileList: imageFiles,
    beforeUpload: (file) => {
      if (!file.type.startsWith("image/")) {
        message.error("Only image files are allowed");
        return Upload.LIST_IGNORE;
      }
      if (file.size > 5 * 1024 * 1024) {
        message.error("Image must be under 5 MB");
        return Upload.LIST_IGNORE;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageFiles((prev) => [
          ...prev,
          {
            uid: file.uid,
            name: file.name,
            status: "done",
            originFileObj: file,
            thumbUrl: e.target.result,
            url: e.target.result,
          },
        ]);
      };
      reader.readAsDataURL(file);
      return false;
    },
    onRemove: (file) =>
      setImageFiles((prev) => prev.filter((f) => f.uid !== file.uid)),
  };

  // ── Submit ───────────────────────────────────────────
  const handleSubmit = async (values) => {
    if (imageFiles.length === 0) {
      message.error("Please upload at least one food image");
      return;
    }

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("description", values.description || "");
    formData.append("price", values.price);
    formData.append("categoryId", values.categoryId);
    formData.append("gstTax", values.gstTax || 0);
    formData.append("cgst_tax", values.cgst_tax || 0);
    formData.append("sgst_tax", values.sgst_tax || 0);
    formData.append("isVeg", isVeg ? "1" : "0");
    if (values.restaurantId) formData.append("restaurantId", values.restaurantId);
    if (values.vendorId) formData.append("vendorId", values.vendorId);

    if (variants.length > 0) {
      const validVariants = variants.filter((v) => v.size && v.price !== "");
      formData.append("variantList", JSON.stringify(validVariants));
    }

    if (ingredients.length > 0) {
      formData.append("ingredientList", JSON.stringify(ingredients));
    }

    imageFiles.forEach((f) => {
      if (f.originFileObj) formData.append("food_images", f.originFileObj);
    });

    setLoader(true);
    try {
      const res = await AddMenu_List(formData);
      if (res?.status) {
        dispatchtoast(res.message || "Menu item added successfully!");
        FetchMenuList();
        handleCancel();
      } else {
        message.error(res?.message || "Failed to add menu item");
      }
    } catch (err) {
      console.error(err);
      message.error("An error occurred. Please try again.");
    } finally {
      setLoader(false);
    }
  };
  console.log("restaurants", restaurants);
  // ── Render ───────────────────────────────────────────
  return (
    <Modal
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      width={680}
      destroyOnClose
      className="add-menu-modal"
      title={
        <div className="flex items-center gap-2">
          <span>🍽️</span>
          <span>Add New Food Item</span>
        </div>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        onFinishFailed={(e) => console.log("Form error:", e)}
        requiredMark="optional"
      >
        {/* ── Basic Info ─────────────────────────── */}
        <div className="grid grid-cols-2 gap-x-4">
          <Form.Item
            name="name"
            label="Food Name"
            rules={[
              { required: true, message: "Enter food name" },
              { whitespace: true, message: "Cannot be blank spaces only" },
              { max: 100, message: "Max 100 characters" },
            ]}
            className="col-span-2"
          >
            <Input
              placeholder="e.g. Paneer Butter Masala"
              size="large"
              prefix={<span className="text-gray-400">🍛</span>}
            />
          </Form.Item>

          <Form.Item
            name="price"
            label="Base Price (₹)"
            rules={[
              { required: true, message: "Enter base price" },
              { type: "number", min: 0, message: "Price must be ≥ 0" },
            ]}
          >
            <InputNumber
              placeholder="0"
              size="large"
              className="w-full"
              min={0}
              prefix="₹"
            />
          </Form.Item>

          <Form.Item
            name="categoryId"
            label="Category"
            rules={[{ required: true, message: "Select a category" }]}
          >
            <Select
              placeholder="Select category"
              size="large"
              loading={loadingCat}
              showSearch
              optionFilterProp="children"
            >
              {categories.map((c) => (
                <Option key={c.id} value={c.id}>
                  {c.categoryName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="restaurantId" label="Restaurant">
            <Select
              placeholder="Select restaurant (optional)"
              size="large"
              loading={loadingRest}
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {restaurants.map((r) => (
                <Option key={r.id} value={r.id}>
                  {r.name || r.restaurantName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="vendorId" label="Vendor">
            <Select
              placeholder="Select vendor (optional)"
              size="large"
              loading={loadingVen}
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {vendors.map((v) => (
                <Option key={v.id} value={v.id}>
                  {v.name} {v.email ? `(${v.email})` : ""}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            className="col-span-2"
          >
            <TextArea
              placeholder="Describe the dish — ingredients, taste, preparation style…"
              rows={3}
              maxLength={500}
              showCount
            />
          </Form.Item>
        </div>

        {/* ── Veg / Non-veg toggle ──────────────── */}
        <div className="flex items-center gap-3 mb-5 p-3 bg-white border border-gray-200 rounded-lg">
          <span className="font-medium text-gray-700 text-sm">Food Type:</span>
          <div
            className={`flex items-center gap-2 px-4 py-1.5 rounded-full cursor-pointer font-semibold text-sm transition-all ${isVeg
                ? "bg-green-100 text-green-700 border border-green-300"
                : "bg-red-100 text-red-700 border border-red-300"
              }`}
            onClick={() => setIsVeg(!isVeg)}
          >
            {isVeg ? (
              <>
                <span>🥦</span> Vegetarian
              </>
            ) : (
              <>
                <FireOutlined /> Non-Vegetarian
              </>
            )}
          </div>
          <span className="text-xs text-gray-400">Click to toggle</span>
        </div>

        {/* ── GST ──────────────────────────────────── */}
        <Divider orientation="left" className="text-sm text-gray-500 !mb-3">
          Tax (optional)
        </Divider>
        <div className="grid grid-cols-3 gap-x-4">
          <Form.Item name="gstTax" label="GST (%)">
            <InputNumber placeholder="e.g. 5" className="w-full" min={0} max={100} />
          </Form.Item>
          <Form.Item name="cgst_tax" label="CGST (%)">
            <InputNumber placeholder="e.g. 2.5" className="w-full" min={0} max={100} />
          </Form.Item>
          <Form.Item name="sgst_tax" label="SGST (%)">
            <InputNumber placeholder="e.g. 2.5" className="w-full" min={0} max={100} />
          </Form.Item>
        </div>

        {/* ── Variants ─────────────────────────────── */}
        <Divider orientation="left" className="text-sm text-gray-500 !mb-3">
          Variants{" "}
          <Tooltip title="Add size options like Half / Full with different prices">
            <InfoCircleOutlined className="text-gray-400 ml-1" />
          </Tooltip>
        </Divider>
        {variants.map((v, i) => (
          <VariantRow
            key={i}
            variant={v}
            index={i}
            onChange={updateVariant}
            onRemove={removeVariant}
          />
        ))}
        <Button
          type="dashed"
          size="small"
          icon={<PlusOutlined />}
          onClick={addVariant}
          className="mb-4"
        >
          Add variant
        </Button>

        {/* ── Ingredients ──────────────────────────── */}
        <Divider orientation="left" className="text-sm text-gray-500 !mb-3">
          Ingredients
        </Divider>
        <div className="flex gap-2 mb-3">
          <Input
            placeholder="e.g. Paneer, Butter, Cream…"
            value={ingredientInput}
            onChange={(e) => setIngredientInput(e.target.value)}
            onPressEnter={addIngredient}
            size="middle"
          />
          <Button onClick={addIngredient} icon={<PlusOutlined />}>
            Add
          </Button>
        </div>
        <div className="flex flex-wrap gap-1.5 mb-4 min-h-[28px]">
          {ingredients.map((ing) => (
            <Tag
              key={ing}
              closable
              onClose={() => removeIngredient(ing)}
              color="blue"
              className="rounded-full"
            >
              {ing}
            </Tag>
          ))}
        </div>

        {/* ── Food Images ───────────────────────────── */}
        <Divider orientation="left" className="text-sm text-gray-500 !mb-3">
          Food Images <span className="text-red-500">*</span>
        </Divider>
        <Upload {...uploadProps}>
          {imageFiles.length < 5 && (
            <div className="flex flex-col items-center gap-1 p-2">
              <PlusOutlined className="text-blue-400 text-lg" />
              <span className="text-xs text-gray-500">Upload</span>
            </div>
          )}
        </Upload>
        <p className="text-xs text-gray-400 mt-1">
          Max 5 images · JPG / PNG · under 5 MB each
        </p>

        {/* ── Footer buttons ────────────────────────── */}
        <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
          <Button size="large" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loader}
            className="bg-blue-600 hover:bg-blue-700 min-w-[130px]"
          >
            Save Food Item
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddMenu;